<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <data-table
          :resource="resources['user']"
          loading="loading"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DataTable from "@/components/DataTable";

export default {
  data() {
    return {
      tab: null
    };
  },

  computed: {
    resources() {
      return this.$store.state.resources;
    },
    firebaseUsers() {
      return this.$store.state.entities.firebaseUsers;
    },
    loading() {
      return Object.keys(this.firebaseUsers).length;
    }
  },

  mounted() {
    this.$store.dispatch("API_GET", {
      url: '/users/firebase',
      entityType: 'firebaseUsers',
      schema: 'firebaseUserListSchema'
    });
  },

  components: {
    DataTable
  }
};
</script>

<style scoped>
</style>
